export function GetURLParameter(sParam) {
    var pageURL = new URL(window.location);
    var params = new URLSearchParams(pageURL.search);
    var value = params.get(sParam);
    return value;
}

// note: you need to add the leading & or ? when calling this function
export function GetUrlContextParametersString() {
    const CURRENT_CONTEXT_PARAM = "current_context";
    let current_context = GetURLParameter(CURRENT_CONTEXT_PARAM);

    let paramString = "";

    if (current_context) {
        current_context = current_context.toLowerCase();
        paramString += `${CURRENT_CONTEXT_PARAM}=${current_context}`;

        const VIEWING_AS_AGENT_ID_PARAM = 'viewing_as_agent_id';
        const VIEWING_AS_AGENT_ID = GetURLParameter("viewing_as_agent_id");

        if ((current_context === 'agent') && VIEWING_AS_AGENT_ID) {
            paramString += `&${VIEWING_AS_AGENT_ID_PARAM}=${VIEWING_AS_AGENT_ID}`;
        }
    }

    return paramString;
}